export const generateClubFormData = (club: Club | null): ClubFormData => {
  return {
    name: club?.name,
    city: club?.address?.city,
    postalCode: club?.address?.postalCode,
    streetAddress: club?.address?.streetAddress,
    streetAddress2: club?.address?.streetAddress2,
    state: getStateFormValue(club?.address?.state),
    country: getCountryFormValue(club?.address?.country),
    timeZone: club?.timeZone?.id,
    email: club?.email,
    phone: club?.phone,
    url: club?.url,
    billingContactName: club?.billingContactName,
    billingContactPhone: club?.billingContactPhone,
    billingContactEmail: club?.billingContactEmail,
    billingContactAddress: club?.billingAddress?.streetAddress,
    billingContactAddress2: club?.billingAddress?.streetAddress2,
    billingContactPostalCode: club?.billingAddress?.postalCode,
    billingContactCity: club?.billingAddress?.city,
    billingContactCountry: getCountryFormValue(club?.billingAddress?.country),
  }
}

const getCountryFormValue = (country: Country | undefined): SelectOption | null => {
  if (!country) {
    return null
  }
  return {
    key: country.id,
    label: country.name,
  }
}

const getStateFormValue = (state: CountryState | undefined): SelectOption | null => {
  if (!state) {
    return null
  }
  return {
    key: state.id,
    label: state.stateName,
  }
}
